/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Senddeletionemail2Inputs */

const en_senddeletionemail2 = /** @type {(inputs: Senddeletionemail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send Deletion Email`)
};

const de_senddeletionemail2 = /** @type {(inputs: Senddeletionemail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschungs-E-Mail senden`)
};

/**
* | output |
* | --- |
* | "Send Deletion Email" |
*
* @param {Senddeletionemail2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const senddeletionemail2 = /** @type {((inputs?: Senddeletionemail2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Senddeletionemail2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_senddeletionemail2(inputs)
	return de_senddeletionemail2(inputs)
});
export { senddeletionemail2 as "sendDeletionEmail" }